import React from "react";

function SearchIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.5-3.5" />
        </svg>
    );
}

// Recherche unique des tableaux de production, interrogée côté serveur.
export default function ProductionSearchBar({ value, onChange, withStatut = false }) {
    const placeholder = withStatut
        ? "EHPAD, patient, produit, classification, statut, date (28/10)…"
        : "EHPAD, patient, produit, classification, date (28/10)…";
    return (
        <div className={`rbt-search${value.trim() ? " is-active" : ""}`}>
            <span className="rbt-search__icon"><SearchIcon /></span>
            <input
                type="search"
                aria-label="Rechercher"
                placeholder={placeholder}
                value={value}
                onChange={event => onChange(event.target.value)}
                onKeyDown={event => { if (event.key === "Escape") onChange(""); }}
            />
            {value && (
                <button type="button" className="rbt-search__clear" aria-label="Effacer la recherche" onClick={() => onChange("")}>
                    ×
                </button>
            )}
        </div>
    );
}
